export const getHash = () => {
  const randomBytes = new Uint32Array(4)
  window.crypto.getRandomValues(randomBytes)
  let result = ''
  for (let i = 0; i < randomBytes.length; i++) {
    result += ('00000000' + randomBytes[i].toString(16)).slice(-8)
  }
  return result
}
